module.exports = __webpack_public_path__ + "img/app_store_white_eng.0f3514a4.svg";